import type { UaePassData } from '@tabbio/types';

function cleanName(value: string | null | undefined): string {
  return (value || '')
    .replace(/[,;/\\|،]+/gu, ' ')
    .replace(/\s+/gu, ' ')
    .trim();
}

function componentName(first: string | undefined, last: string | undefined) {
  return cleanName([cleanName(first), cleanName(last)].filter(Boolean).join(' '));
}

export function resolveUaePassLegalName(
  data: UaePassData | null | undefined,
  fallback = '',
): string {
  return (
    cleanName(data?.fullNameEN) ||
    cleanName(data?.fullNameAR) ||
    componentName(data?.firstNameEN, data?.lastNameEN) ||
    componentName(data?.firstNameAR, data?.lastNameAR) ||
    cleanName(fallback)
  );
}

export function resolveUaePassCvName(
  data: UaePassData | null | undefined,
  fallback = '',
): string {
  return (
    componentName(data?.firstNameEN, data?.lastNameEN) ||
    componentName(data?.firstNameAR, data?.lastNameAR) ||
    cleanName(data?.fullNameEN) ||
    cleanName(data?.fullNameAR) ||
    cleanName(fallback)
  );
}
